import { NG_VALIDATORS, UntypedFormControl, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appEmailValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: EmailValidatorDirective, multi: true }],
})
export class EmailValidatorDirective implements Validator {
    validate(field: UntypedFormControl) {
        if (field.value) {
            const EMAIL_REGEXP =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return EMAIL_REGEXP.test(field.value.trim())
                ? null
                : {
                      validateEmail: {
                          invalid: true,
                      },
                  };
        } else {
            return null;
        }
    }
}
